module.exports = __webpack_public_path__ + "img/marker-ds.261ed7b1.svg";